<forge-card *ngIf="loaded" class="no-padding">
    <form>
        <metadata-view [ngModelGroup]="view.title" [viewTitle]="view.title" [view]="view"
                       [datacontroller]="datacontroller"></metadata-view>
    </form>
</forge-card>